module.exports = __webpack_public_path__ + "img/slider_2.6801349b.png";